// @flow

import {
  SAVE_LANDING_USER_DATA,
  WS_GET_LANDING_REQUEST,
  WS_GET_LANDING_SUCCESS,
  WS_GET_LANDING_ERROR,
} from '../../store/actions';
import type { ApiState, LandingState, LandingActions } from '../types';

const requestInitialState = (): ApiState<any, any, any> => ({
  loading: false,
  time: null,
  success: false,
  params: null,
  error: null,
  response: null,
});

export const initialState: LandingState = {
  createUserData: null,
  getLanding: requestInitialState(),
};

export const landingReducer = (
  state: LandingState = initialState,
  action: LandingActions,
): LandingState => {
  switch (action.type) {
    case SAVE_LANDING_USER_DATA:
      return {
        ...state,
        createUserData: action.payload,
      };
    case WS_GET_LANDING_REQUEST:
      return {
        ...state,
        getLanding: {
          loading: true,
          time: Date.now(),
          success: false,
          params: action.payload,
          error: null,
          response: null,
        },
      };
    case WS_GET_LANDING_SUCCESS:
      return {
        ...state,
        getLanding: {
          ...state.getLanding,
          loading: false,
          time: null,
          success: true,
          error: null,
          response: action.payload,
        },
      };
    case WS_GET_LANDING_ERROR:
      return {
        ...state,
        getLanding: {
          ...state.getLanding,
          loading: false,
          time: null,
          success: false,
          error: action.payload,
          response: null,
        },
      };
    default:
      return state;
  }
};
